let QuickSearch = function (props) {
  let {
    term = "",
    results,
    placeholder,
    onChange,
    onSubmit
  } = props;

  let doChange = function (evt) {
    onChange(evt.target.value);
  };

  let doSubmit = function (evt) {
    if (results.length === 1) {
      onSubmit(results[0]);
    }

    if (evt) {
      evt.preventDefault();
    }
  };

  return (
    <form className="mc-quick-search" onSubmit={doSubmit}>
      <input
        type="search"
        value={term}
        onChange={doChange}
        placeholder={placeholder}
        data-matched={term.length > 0 && results.length === 1}/>
    </form>
  );
};

module.exports = QuickSearch;
